import * as http from '@/api/config';

/* 获取文章 */
export function getAdminArticleList(data) {
	const url = 'article/admin/v1/article/list';
	return http.$get(url, data);
}
/* 文章详情 */
export function getAdminArticleInfo(uuid) {
    const url = 'article/admin/v1/article/info/' + uuid;
    return http.$get(url);
}
/* 新增文章 */
export function createAdminArticle(data) {
    const url = 'article/admin/v1/article/create';
    return http.$post(url, data);
}
/* 编辑文章 */
export function updateAdminArticleBaseMessage(uuid, data) {
    const url = 'article/admin/v1/article/update/' + uuid;
    return http.$put(url, {
        ...data,
        type: 'base',
    });
}
/* 编辑文章内容 */
export function updateAdminArticleContent( uuid, content) {
    const url = 'article/admin/v1/article/update/' + uuid;
    return http.$put(url, {
        content: content,
        type: 'content',
    });
}

/* 关闭文章 */
export function closeAdminArticle(uuid) {
    const url = 'article/admin/v1/article/close/' + uuid;
    return http.$put(url);
}
/* 发布文章 */
export function publishAdminArticle(uuid) {
    const url = 'article/admin/v1/article/publish/' + uuid;
    return http.$put(url);
}
/* 复制文章 */
export function copyAdminArticle(uuid) {
    const url = 'article/admin/v1/article/copy/' + uuid;
    return http.$post(url);
}
/* 置顶文章 */
export function setAdminArticleTop(uuid) {
    const url = 'article/admin/v1/article/top/' + uuid;
    return http.$put(url, {
        value: 1,
    });
}
/* 取消置顶文章 */
export function cancelAdminArticleTop(uuid) {
    const url = 'article/admin/v1/article/top/' + uuid;
    return http.$put(url, {
        value: 0,
    });
}
/* 删除文章 */
export function deleteAdminArticle(uuid) {
    const url = 'article/admin/v1/article/delete/' + uuid;
    return http.$delete(url);
}
/* 获取我的文章 */
export function getMineArticle(data) {
	const url = 'article/home/v1/article/mine';
	return http.$get(url, data);
}
/* 获取文章详情 */
export function getHomeArticleInfo(uuid) {
    const url = 'article/home/v1/article/info/' + uuid;
    return http.$get(url);
}
/* 获取文章分类列表 */
export function getAdminArticleCateList() {
    const url = 'article/admin/v1/category/list';
    return http.$get(url);
}
/* 获取文章分类下级列表 */
export function getAdminArticleCateChild(uuid) {
    const url = 'article/admin/v1/category/child/' + uuid;
    return http.$get(url);
}
/* 新增文章分类 */
export function createAdminArticleCate(data) {
    const url = 'article/admin/v1/category/create';
    return http.$post(url, data);
}
/* 获取文章分类详情 */
export function getAdminArticleCateInfo(uuid) {
    const url = 'article/admin/v1/category/info/' + uuid;
    return http.$get(url);
}
/* 编辑文章分类 */
export function updateAdminArticleCate(uuid, data) {
    const url = 'article/admin/v1/category/update/' + uuid;
    return http.$put(url, data);
}
/* 排序文章分类 */
export function sortAdminArticleCate(data) {
    const url = 'article/admin/v1/category/sort';
    return http.$post(url, data);
}
/* 删除文章分类 */
export function deleteAdminArticleCate(uuid) {
    const url = 'article/admin/v1/category/delete/' + uuid;
    return http.$delete(url);
}




// WEBPACK FOOTER //
// ./src/api/module/article.js